import immutable from 'immutable';
import { OPERATION_STATUS } from 'util/config/constant';
import { updateBaseTableReducer } from 'util/reducer/update';
import {
  CREATE_OPERATOR_ERROR,
  CREATE_OPERATOR_REQUEST,
  CREATE_OPERATOR_SUCCESS,
  DELETE_OPERATORS_FAIL,
  DELETE_OPERATORS_REQUEST,
  DELETE_OPERATORS_SUCCESS,
  GET_OPERATORS_FAIL,
  GET_OPERATORS_REQUEST,
  GET_OPERATORS_SUCCESS,
  RESET_OPERATORS_STATE,
  UPDATE_OPERATORS_FAIL,
  UPDATE_OPERATORS_REQUEST,
  UPDATE_OPERATORS_SUCCESS
} from './action';

export const init = () => {
  const initValue = immutable.fromJS({
    list: undefined,
    create: undefined,
    update: undefined
  });

  return initValue
    .set('list', {
      data: [],
      isLoading: false,
      effect: 0,
      total: 0
    })
    .set('create', {
      isLoading: false,
      status: OPERATION_STATUS.DEFAULT
    })
    .set('update', {
      updatingOperatorValues: {}
    });
};

export default function operatorsReducer(state = init(), action) {
  const { payload } = action;

  switch (action.type) {
    case GET_OPERATORS_REQUEST:
      return state.update('list', (list) => ({
        ...list,
        isLoading: true
      }));

    case GET_OPERATORS_SUCCESS: {
      const {
        payload: { data }
      } = action;

      const total = data?.operators?.metadata?.totalCount;
      const operators = data?.operators?.data;

      return state.update('list', (list) =>
        updateBaseTableReducer(list, operators, { total })
      );
    }

    case GET_OPERATORS_FAIL:
      return state.update('list', (list) => ({
        ...list,
        isLoading: false
      }));

    case DELETE_OPERATORS_REQUEST: {
      return state.update('list', (list) => {
        const data = list.data.map((operator) => {
          if (operator.id === payload.id) {
            operator.isDeleted = true;
          }

          return operator;
        });

        return {
          ...list,
          data,
          total: list.total - 1
        };
      });
    }

    case DELETE_OPERATORS_SUCCESS: {
      return state.update('list', (list) => {
        const data = list.data.filter((operator) => operator.id !== payload.id);

        return {
          ...list,
          data
        };
      });
    }

    case DELETE_OPERATORS_FAIL: {
      return state.update('list', (list) => {
        const data = list.data.map((operator) => {
          if (operator.id === payload.id) {
            operator.isDeleted = false;
          }

          return operator;
        });

        return {
          ...list,
          data,
          total: list.total + 1
        };
      });
    }

    case CREATE_OPERATOR_REQUEST:
      return state.set('create', {
        isLoading: true,
        status: OPERATION_STATUS.DEFAULT
      });

    case CREATE_OPERATOR_SUCCESS: {
      return state
        .update('list', (list) => ({
          ...list,
          effect: state.get('list').effect + 1
        }))
        .set('create', {
          isLoading: false,
          status: OPERATION_STATUS.SUCCESS
        });
    }

    case CREATE_OPERATOR_ERROR:
      return state.set('create', {
        isLoading: false,
        status: OPERATION_STATUS.FAIL
      });

    case UPDATE_OPERATORS_REQUEST: {
      return state.update('update', (data) => ({
        ...data,
        updatingOperatorValues: {
          ...data.updatingOperatorValues,
          [payload.id]: true
        }
      }));
    }

    case UPDATE_OPERATORS_SUCCESS: {
      return state
        .update('update', (data) => ({
          ...data,
          updatingOperatorValues: {
            ...data.updatingOperatorValues,
            [payload.id]: false
          }
        }))
        .update('list', (list) => ({
          ...list,
          effect: state.get('list').effect + 1
        }));
    }

    case UPDATE_OPERATORS_FAIL: {
      return state.update('update', (data) => ({
        ...data,
        updatingOperatorValues: {
          ...data.updatingOperatorValues,
          [payload.id]: false
        }
      }));
    }

    case RESET_OPERATORS_STATE:
      return init();

    default:
      return state;
  }
}
